import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableauUserFragmentGql } from './TableauUserFragmentGql'

// TODO: to use these we need the "back end" feature flag for dqcertification - the FeatureFlags type in data-catalog-shared must be udpated
const DataQualityCertificationFragmentGql: DocumentNode = gql`
fragment DataQualityCertificationFragment on DataQualityCertification {
  __typename
  vizportalId
  isActive
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUserFragment
  }
}
${TableauUserFragmentGql}
`;

const DataQualityCertificationAssetFragmentGql: DocumentNode = gql`
fragment DataQualityCertificationAssetFragment on DataQualityCertification {
  asset {
    id
    __typename
    ... on PublishedDatasource {
      vizportalUrlId
      name
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
      name
    }
    ... on VirtualConnectionTable @flag(enabled: $publishedConnectionsLineageEnabled) {
      name
    }
  }
}
`;

export const CertificationsFragmentGql: DocumentNode = gql`
fragment CertificationsFragment on Certifiable {
  dataQualityCertifications {
    ...DataQualityCertificationFragment
    ...DataQualityCertificationAssetFragment
  }
}
${DataQualityCertificationFragmentGql}
${DataQualityCertificationAssetFragmentGql}
`;


